'use client'
import { useEffect } from 'react'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'

// TODO: I moved this into a client side component as it contains client side logic for fixing hash.
// Ideally this should be in a Provider.
const HashFixer = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (window) {
      let hash = window.location.hash
      if (!hash) {
        return
      } else {
        let anchorIndex = hash.indexOf('#')
        let queryIndex = hash.indexOf('?')
        if (queryIndex > anchorIndex && queryIndex > -1 && anchorIndex > -1) {
          let dividedUrl = hash.split('#')
          let anchorAndQuery = dividedUrl[1].split('?')
          if (pathname) {
            router.replace(
              `${pathname.split('#')[0]}${dividedUrl[0]}?${anchorAndQuery[1]}#${anchorAndQuery[0]}`
            )
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  return null
}

export default HashFixer
